import {
  APPROVES_TEAMS,
  REJECTS_TEAMS,
  TEAMS_APPROVES_ERROR,
  TEAMS_APPROVES_SUCCESS,
  TEAMS_REJECTS_ERROR,
  TEAMS_REJECTS_SUCCESS,
  TEAMS_USER_ERROR,
  TEAMS_USER_SUCCESS,
  USER_TEAMS,
  WORK_REPORTS,
  WORK_REPORTS_ERROR,
  WORK_REPORTS_SUCCESS,
  SEND_REPORT_FOR_SELECTED_PROJECT,
  EVALUATION_HOURS,
  EVALUATION_HOURS_SUCCESS,
  EVALUATION_HOURS_ERROR,
  REPORT_QUICK_SEND_TO_CLIENT,
  REPORT_QUICK_SEND_TO_CLIENT_SUCCESS,
  REPORT_QUICK_SEND_TO_CLIENT_ERROR,
  SET_MODAL,
  SET_ROW_LIST_DATA,
  SET_MOBILE_VIEW,
  SET_SELECTED_ARRAY_LISTS,
  SET_SELECTED_REPORT_ITEM,
  SET_SELECTE_TOGGLE,
  SET_TEAM_SCREEN_MODAL,
  SET_ACTIVE_SCREEN_FILTER,
  SET_VERIFY_SCREEN,
  SET_SUMMARY_DATA_TEAM,
  SET_SUMMARY_MODAL_TEAM,
  SET_SUMMARY_MODAL,
  SET_SUMMARY_DATA,

  SET_FULL_VIEW_MODAL_TEAM,
  SET_FULL_VIEW_REPORT,
  SET_SELECTED_HOURS_TEAM,
  GET_HOURS_REPORT,
  GET_HOURS_REPORT_SUCCESS,
  GET_HOURS_REPORT_ERROR,
  SET_BOOK_MARKS,
  UPDATE_BOOK_MARKS_LISTS
} from "./actionType"

export const getUserTeamsReport = teams => {
  return {
    type: USER_TEAMS,
    payload: teams,
  }
}
export const getUserTeamsReportSuccess = Teams => {
  return {
    type: TEAMS_USER_SUCCESS,
    payload: Teams,
  }
}

export const getUserTeamsReportError = Teams => {
  return {
    type: TEAMS_USER_ERROR,
    payload: Teams,
  }
}

export const getApprovesTeamsReport = data => {
  return {
    type: APPROVES_TEAMS,
    payload: data,
  }
}
export const getApprovesTeamsReportSuccess = data => {
  return {
    type: TEAMS_APPROVES_SUCCESS,
    payload: data,
  }
}

export const getApprovesTeamsReportError = data => {
  return {
    type: TEAMS_APPROVES_ERROR,
    payload: data,
  }
}

export const getRejectsTeamsReport = data => {
  return {
    type: REJECTS_TEAMS,
    payload: data,
  }
}
export const getRejectsTeamsReportSuccess = data => {
  return {
    type: TEAMS_REJECTS_SUCCESS,
    payload: data,
  }
}

export const getRejectsTeamsReportError = data => {
  return {
    type: TEAMS_REJECTS_ERROR,
    payload: data,
  }
}
export const workReports = data => {
  return {
    type: WORK_REPORTS,
    payload: data,
  }
}
export const workReportsSuccess = data => {
  return {
    type: WORK_REPORTS_SUCCESS,
    payload: data,
  }
}
export const workReportsError = data => {
  return {
    type: WORK_REPORTS_ERROR,
    payload: data,
  }
}

export const SendReportForSelectedProject = (data, callback) => {
  return {
    type: SEND_REPORT_FOR_SELECTED_PROJECT,
    payload: data,
    callback
  }
}

export const GetOnEvaluationHours = data => {
  return {
    type: EVALUATION_HOURS,
    payload: data
  }
}

export const GetOnEvaluationHoursSuccess = data => {
  return {
    type: EVALUATION_HOURS_SUCCESS,
    payload: data
  }
}

export const GetOnEvaluationHoursError = data => {
  return {
    type: EVALUATION_HOURS_ERROR,
    payload: data
  }
}


// client mail sent report
export const PostReportQuickSendToClient = (data, callback) => {
  return {
    type: REPORT_QUICK_SEND_TO_CLIENT,
    payload: data,
    callback
  }
}

export const PostReportQuickSendToClientSuccess = data => {
  return {
    type: REPORT_QUICK_SEND_TO_CLIENT_SUCCESS,
    payload: data
  }
}

export const PostReportQuickSendToClientError = data => {
  return {
    type: REPORT_QUICK_SEND_TO_CLIENT_ERROR,
    payload: data
  }
}

// ** global ** //
export const setismodal = data => {
  return {
    type: SET_MODAL,
    payload: data
  }
}

export const setRowlistData = data => {
  return {
    type: SET_ROW_LIST_DATA,
    payload: data
  }
}

export const setIsMobile = data => {
  return {
    type: SET_MOBILE_VIEW,
    payload: data
  }
}

export const setSelectedArrayLists = data => {
  return {
    type: SET_SELECTED_ARRAY_LISTS,
    payload: data
  }
}

export const setSelectedReportItem = data => {
  return {
    type: SET_SELECTED_REPORT_ITEM,
    payload: data
  }
}

export const setselecToggle = data => {
  return {
    type: SET_SELECTE_TOGGLE,
    payload: data
  }
}

export const setTeamscreenModal = data => {
  return {
    type: SET_TEAM_SCREEN_MODAL,
    payload: data
  }
}

export const setverifyScreen = data => {
  return {
    type: SET_VERIFY_SCREEN,
    payload: data
  }
}

export const setActiveScreenFilter = data => {
  return {
    type: SET_ACTIVE_SCREEN_FILTER,
    payload: data
  }
}
export const setSummarydatateam = data => {
  return {
    type: SET_SUMMARY_DATA_TEAM,
    payload: data
  }
}
export const setSummaryModalteam = data => {
  return {
    type: SET_SUMMARY_MODAL_TEAM,
    payload: data
  }
}

export const setSummarydata = data => {
  return {
    type: SET_SUMMARY_DATA,
    payload: data
  }
}
export const setSummaryModal = data => {
  return {
    type: SET_SUMMARY_MODAL,
    payload: data
  }
}


export const setFullviewreport = data => {
  return {
    type: SET_FULL_VIEW_REPORT,
    payload: data
  }
}
export const setFullviewModalteam = data => {
  return {
    type: SET_FULL_VIEW_MODAL_TEAM,
    payload: data
  }
}

export const setSelectedHoursteam = data => {
  return {
    type: SET_SELECTED_HOURS_TEAM,
    payload: data
  }
}
  // get api for hours report action 
  export const getHoursReport = (params, download,exportname) => ({
    type: GET_HOURS_REPORT,
    payload: params,
    exports: download,
    exportname:exportname
  })
  
  export const getHoursReportSuccess = hoursReport => ({
    type: GET_HOURS_REPORT_SUCCESS,
    payload: hoursReport,
  })
  
  export const getHoursReportError = error => ({
    type: GET_HOURS_REPORT_ERROR,
    payload: error,
  })
  
  export const setBookMarkedLists = data => ({
    type: SET_BOOK_MARKS,
    payload: data,
  })

  export const UpdateBookMarkedLists = data => ({
    type: UPDATE_BOOK_MARKS_LISTS,
    payload: data,
  }) 
  